<template>
  <div>
    <!--    <div class="row">-->
    <!--      <div class="col-12 offset-md-3 col-md-5 mb-md-1">-->
    <!--        <div-->
    <!--          class="portfolio-buttons inbox-buttons"-->
    <!--          v-if="$route.name === 'messages' || $route.name === 'exports'"-->
    <!--        >-->
    <!--          <button-->
    <!--            type="button"-->
    <!--            class="btn"-->
    <!--            :class="{-->
    <!--              active: currentFilter === null-->
    <!--            }"-->
    <!--            @click="select(null)"-->
    <!--          >-->
    <!--            Všetky roky-->
    <!--          </button>-->
    <!--          <button-->
    <!--            type="button"-->
    <!--            class="btn"-->
    <!--            v-for="item in filter"-->
    <!--            :class="{-->
    <!--              active: currentFilter === item-->
    <!--            }"-->
    <!--            @click="select(item)"-->
    <!--          >-->
    <!--            {{ item }}-->
    <!--          </button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="row">
      <div class="col-md-3 col-12">
        <div class="card">
          <div class="card-body p-0">
            <ul class="vertical-nav">
              <li>
                <router-link :to="{ name: 'messages' }">
                  {{ $t("messages") }}
                  <span class="ml-1" v-if="status.type_1 > 0">
                    ({{ status.type_1 }})
                  </span>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'instructions' }">
                  {{ $t("instructions") }}
                  <span class="ml-1" v-if="status.type_2 > 0">
                    ({{ status.type_2 }})
                  </span>
                  <span></span>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'confirmations' }">
                  {{ $t("confirmations") }}
                  <span class="ml-1" v-if="status.type_3 > 0">
                    ({{ status.type_3 }})
                  </span>
                  <span></span>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'reports' }">
                  {{ $t("reports") }}
                  <span class="ml-1" v-if="status.type_4 > 0">
                    ({{ status.type_4 }})
                  </span>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'contracts' }">
                  {{ $t("contracts") }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-9 col-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Messages",
  data() {
    return {
      currentFilter: null
    };
  },
  computed: {
    status() {
      return this.$store.state.messages.status;
    }
    // filter() {
    //   if (this.$route.name === "messages") {
    //     return this.$store.state.messages.filter;
    //   } else if (this.$route.name === "exports") {
    //     return this.$store.state.exports.filter;
    //   }
    // }
  },
  methods: {
    // select(year) {
    //   this.currentFilter = year;
    //   if (this.$route.name === "messages") {
    //     this.$store.commit("messages/filter", year);
    //     return this.$store.state.messages.filter;
    //   }
    // }
  }
};
</script>

<style scoped></style>
